module.exports = __webpack_public_path__ + "assets/c14c251c85c36727d3e189714b8ecee0.png";